export default class PedidoObservacoesViewModel {
	constructor() {
		this.Id = undefined;
		this.PedidoId = undefined;
		this.ProdutoId = undefined;
		this.OrcamentoId = undefined;
		this.DataBasePedidoFormatada = undefined;
		this.PedidoParcelaId = undefined;
		this.PedidoObservacaoId = undefined;
		this.CnpjFormatado = undefined;
		this.NumeroQuantidadeTotalFormatado = undefined;
		this.Codigo = undefined;
		this.QuantidadeExpedida = undefined;
		this.QuantidadeExpandida = undefined;
		this.LiberadoParaProduzir = undefined;
		this.RazaoSocial = undefined;
		this.DataBasePedidoFormatada = undefined;
		this.NomeRepresentante = undefined;
		this.NomeEmpresa = undefined;
		this.NomeProduto = undefined;
		this.DescricaoFaseProduto = undefined;
		this.QuantidadeProduzida = undefined;
		this.CodigoExterno = undefined;
		this.CodigoExternoPedido = undefined;
		this.ComponenteTipoEnumTexto = undefined;
		this.DataEntregaFormatada = undefined;
		this.TipoPedidoTexto = undefined;
		this.CurvaClienteTexto = undefined;
		this.DataCarregamentoFormatada = undefined;
		this.NumeroOrdemDeCompra = undefined;
		this.NumeroQuantidadeTotal = undefined;
		this.NumeroParcela = undefined;
		this.DataBasePedidoParcelaFormatada = undefined;
		this.NumeroParcelaPedido = undefined;
		this.DescricaoOrigem = undefined;
		this.DescricaoObservacao = undefined;
		this.DescricaoDestino = undefined;
	}
}